module.exports = __webpack_public_path__ + "assets/img/phyto_calm.5a1d1a0d.svg";